import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import SearchResults from '../../components/Search/SearchResults';
import { SearchType } from '../../models/search.interface';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    dialogContent: {
      overflow: 'hidden',
    },
  }),
);

interface IAddToCartDialog {
  open: boolean;
  onClose: () => void;
  item: SearchType;
  vin: string;
}

export const AddToCartDialog = ({ open, onClose, item, vin }: IAddToCartDialog) => {
  const classes = useStyles();
  return ( 
    <Dialog 
      onClose={() => {onClose()}}
      aria-labelledby="add-to-cart-dialog-title" 
      open={open}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="submit-dialog-title">Add To Cart</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <SearchResults searchResult={item} vin={vin} clearSearch={onClose}/>
      </DialogContent>
    </Dialog>
  );
}
